module.exports = __webpack_public_path__ + "static/media/ryan_taft_avatar.3e624840.png";